import React, {useEffect, useState, useMemo} from "react";
import { RussianRuble, BarChart3, Users, TrendingUp, FileText, Badge, ArrowUpDown, Filter, Search } from "lucide-react"
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, PieChart, Pie, Cell } from 'recharts'
import { Select, SelectTrigger, SelectValue, SelectContent, SelectItem } from './ui/select';
import { Input } from './ui/input';
import { Button } from "./ui/button";
import { API_URL } from "../config";
import { authFetch } from "../utils/authFetch";


export function AdminStatistic() {
    // const [documents, setDocuments] = useState([]);
    const [analyticsStats, setAnalyticsStats] = useState([]);
      const [earningsData, setEarningsData] = useState([]);
      const [searchTerm, setSearchTerm] = useState('');
      const [statusFilter, setStatusFilter] = useState('all');
      const [sortOrder, setSortOrder] = useState('asc');
      const [sortBy, setSortBy] = useState('earnings');
    
      const periods = [
        { id: 'day',   label: 'День' },
        { id: 'week',  label: 'Неделя' },
        { id: 'month', label: 'Месяц' },
        { id: 'year',  label: 'Год' },
        { id: 'all',   label: 'Весь период' },
        { id: 'custom',label: 'Свои даты' },
      ];
    
      const [period, setPeriod] = useState('all');
      const today = new Date().toISOString().slice(0, 10);
      const [customDates, setCustomDates] = useState({ from: today, to: today });
    
      // когда меняется period или customDates, пересчитываем earningsData:
      useEffect(() => {
        let from, to = new Date();
        switch (period) {
          case 'day':
            from = new Date(Date.now() - 24*3600*1000);
            break;
          case 'week':
            from = new Date(Date.now() - 7*24*3600*1000);
            break;
          case 'month':
            from = new Date();
            from.setMonth(from.getMonth() - 1);
            break;
          case 'year':
            from = new Date();
            from.setFullYear(from.getFullYear() - 1);
            break;
          case 'all':
            from = new Date("1970-01-01"); // посылаем ВСЕГДА
            break;
          case 'custom':
            from = customDates.from ? new Date(customDates.from) : null;
            to   = customDates.to   ? new Date(customDates.to)   : to;
            break;
        }
        const qs = [];
        qs.push(`from=${from.toISOString().slice(0, 10)}`);
        qs.push(`to=${to.toISOString().slice(0, 10)}`);
        const url = `${API_URL}/analytics/documents/all-authors${qs.length? '?'+qs.join('&') : ''}`;
        const jwt = localStorage.getItem('token');
        authFetch(url, {
            method: 'GET',
            headers: { Authorization: `Bearer ${jwt}` }
            })
            .then(res => {
            if (!res.ok) throw new Error(`HTTP ${res.status}`);
            return res.json();
            })
            .then(data => {
            console.log('analytics data', data);
            setAnalyticsStats(data.analyticsStats);
            setEarningsData(data.earningsData);
            })
            .catch(err => console.error('Fetch analytics error:', err));
      }, [period, customDates]);
    
    
      const totalEarnings = useMemo(
        () => analyticsStats.reduce((sum, s) => sum + Number(s.earnings), 0),
        [analyticsStats]
      );
      const totalSales = useMemo(
        () => analyticsStats.reduce((sum, s) => sum + Number(s.sales_count), 0),
        [analyticsStats]
      );
    
    // Категории из загрузки
    const categoriesMap = [
    { id: 'workCult', name: 'Культура работы' },
    { id: 'projManag', name: 'Управление проектами' },
    { id: 'operEff', name: 'Операционная эффективность' },
    { id: 'hr', name: 'HR' },
    { id: 'demandPlann', name: ' Планирование потребности' },
    { id: 'provisPlann', name: 'Планирование обеспечения' },
    { id: 'purch', name: 'Закупки' },
    { id: 'logic', name: 'Логистика' },
    { id: 'money', name: 'Финансы' },
    { id: 'nsi', name: 'Развитие НСИ' },
    { id: 'automat', name: 'Автоматизация' },
    { id: 'strat', name: 'Стратегия' }
    ];
    
    // Statistics calculations
  const totalDocuments = analyticsStats.length;
  const pendingDocuments = analyticsStats.filter(doc => doc.status === 'pending').length;
  const approvedDocuments = analyticsStats.filter(doc => doc.status === 'approved').length;
  const rejectedDocuments = analyticsStats.filter(doc => doc.status === 'rejected').length;
  
  const platformCommission = totalEarnings * 0.05;
  
  // Categories for statistics
  const categories = [...new Set(analyticsStats.map(doc => doc.category))]

  // Chart data
  const statusData = [
    { name: 'Одобрено', value: approvedDocuments, color: '#10B981' },
    { name: 'На модерации', value: pendingDocuments, color: '#F59E0B' },
    { name: 'Отклонено', value: rejectedDocuments, color: '#EF4444' }
  ]



  const getStatusBadge = (status) => {
    switch (status) {
      case 'pending':
        return <p style={{color: 'orange'}}>На модерации</p>
      case 'approved':
        return <p style={{color: 'green'}}>Одобрено</p>
      case 'rejected':
        return <p style={{color: 'red'}}>Отклонено</p>
      default:
        return null
    }
  }


    return (
        <div className="p-3 sm:p-6 space-y-6 max-w-6xl mx-auto">
        {/* Header */}
        <div className="text-center space-y-2">
            <h1 className="gradient-text text-2xl sm:text-3xl font-bold">Статистика платформы</h1>
            <p className="text-gray-600 text-sm sm:text-base">
            Аналитика доходов и общая статистика по документам
            </p>
        </div>

        <div className="flex">
          <Select value={period} onValueChange={setPeriod}>
            <SelectTrigger className="w-48">
              <SelectValue placeholder="Период" />
            </SelectTrigger>
            <SelectContent>
              {periods.map(p => (
                <SelectItem key={p.id} value={p.id}>{p.label}</SelectItem>
              ))}
            </SelectContent>
          </Select>
          {period === 'custom' && (
            <>
              <Input
                type="date"
                value={customDates.from}
                onChange={e =>
                  setCustomDates(d => ({ ...d, from: e.target.value }))
                }
                className="w-36"
              />
              <Input
                type="date"
                value={customDates.to}
                onChange={e =>
                  setCustomDates(d => ({ ...d, to: e.target.value }))
                }
                className="w-36"
              />
            </>
          )}
        </div>

        {/* Revenue Stats */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-3 sm:gap-6">
            <div className="bg-white p-3 sm:p-4 rounded-lg border">
            <div className="flex items-center gap-2">
                <RussianRuble className="h-4 w-4 sm:h-5 sm:w-5 text-green-600" />
                <span className="text-xs sm:text-sm text-gray-600">Общий оборот</span>
            </div>
            <p className="text-lg sm:text-2xl font-semibold mt-2">{totalEarnings}₽</p>
            {/* <p className="text-[10px] sm:text-xs text-green-600 mt-1">+15% за месяц</p> */}
            </div>
            <div className="bg-white p-3 sm:p-4 rounded-lg border">
            <div className="flex items-center gap-2">
                <BarChart3 className="h-4 w-4 sm:h-5 sm:w-5 text-blue-600" />
                <span className="text-xs sm:text-sm text-gray-600">Комиссия платформы (15%)</span>
            </div>
            <p className="text-lg sm:text-2xl font-semibold mt-2">{(totalEarnings * 0.15).toFixed(2)}₽</p>
            {/* <p className="text-[10px] sm:text-xs text-blue-600 mt-1">+12% за месяц</p> */}
            </div>
        </div>

        {/* Charts */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
            {/* Revenue Chart */}
            <div className="bg-white rounded-lg border">
            <div className="p-4 sm:p-6 border-b">
                <h3 className="font-semibold flex items-center gap-2 text-sm sm:text-base">
                <TrendingUp className="h-4 w-4 sm:h-5 sm:w-5" />
                Динамика доходов
                </h3>
            </div>
            <div className="p-3 sm:p-6">
                <div className="h-48 sm:h-64">
                    {earningsData[0] ? (
                        <ResponsiveContainer width="100%" height="100%">
                    <LineChart data={earningsData}>
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis dataKey="day" fontSize={12} />
                    <YAxis fontSize={12} />
                    <Tooltip
                        formatter={(value, name) =>
                        name === 'Доход'
                            ? [`${value}₽`, 'Доход']
                            : [`${value}`, 'Скачивания']
                        }
                    />
                    <Line
                        type="monotone"
                        dataKey="earnings"
                        stroke="#2563eb"
                        strokeWidth={2}
                        dot={{ r: 3, strokeWidth: 2 }}
                        name="Доход"
                    />
                    <Line
                        type="monotone"
                        dataKey="downloads"
                        stroke="#22c55e" // зелёный
                        strokeWidth={2}
                        dot={{ r: 3, strokeWidth: 2 }}
                        name="Скачивания"
                    />
                    </LineChart>
                </ResponsiveContainer>
                    ) : (
                        <p>
                            На эту дату нет документов
                        </p>
                    )}
                
                </div>
            </div>
            </div>

            {/* Status Pie Chart */}
            <div className="bg-white rounded-lg border">
            <div className="p-4 sm:p-6 border-b">
                <h3 className="font-semibold flex items-center gap-2 text-sm sm:text-base">
                <BarChart3 className="h-4 w-4 sm:h-5 sm:w-5" />
                Статистика документов
                </h3>
            </div>
            <div className="p-3 sm:p-6">
                <div className="h-48 sm:h-64">
                    {statusData[0] ? (
                        <ResponsiveContainer width="100%" height="100%">
                    <PieChart>
                    <Pie
                        data={statusData}
                        cx="50%"
                        cy="50%"
                        innerRadius={40}
                        outerRadius={80}
                        paddingAngle={5}
                        dataKey="value"
                    >
                        {statusData.map((entry, index) => (
                        <Cell key={`cell-${index}`} fill={entry.color} />
                        ))}
                    </Pie>
                    <Tooltip />
                    </PieChart>
                </ResponsiveContainer>
                    ) : (
                        <p>
                            На эту дату нет документов
                        </p>
                    )}
                </div>
                <div className="flex flex-col sm:flex-row sm:justify-center gap-2 sm:gap-4 mt-4">
                {statusData.map((entry, index) => (
                    <div key={index} className="flex items-center gap-2">
                    <div 
                        className="w-3 h-3 rounded-full" 
                        style={{ backgroundColor: entry.color }}
                    />
                    <span className="text-xs sm:text-sm text-gray-600">{entry.name}: {entry.value}</span>
                    </div>
                ))}
                </div>
            </div>
            </div>
        </div>

        <div className="p-3 sm:p-6">
            <div className="flex flex-col gap-3 sm:gap-4 mb-6">
                  <div className="relative">
                    <Search className="absolute left-3 top-3 h-4 w-4 text-gray-400" />
                    <Input
                      placeholder="Поиск по названию документа..."
                      value={searchTerm}
                      onChange={(e) => setSearchTerm(e.target.value)}
                      className="pl-10 text-sm"
                    />
                  </div>
          </div>
          <div className="flex flex-col sm:flex-row gap-2 sm:gap-4">
            <Select value={statusFilter} onValueChange={setStatusFilter}>
              <SelectTrigger className="w-full sm:w-48">
                <Filter className="h-4 w-4 mr-2" />
                <SelectValue placeholder="Статус" />
              </SelectTrigger>
              <SelectContent>
                <SelectItem value="all">Все статусы</SelectItem>
                <SelectItem value="approved">Активные</SelectItem>
                <SelectItem value="pending">На модерации</SelectItem>
              </SelectContent>
            </Select>
            <Select value={sortBy} onValueChange={setSortBy}>
                <SelectTrigger className="w-full sm:w-48">
                  <ArrowUpDown className="h-4 w-4 mr-2" />
                  <SelectValue placeholder="Сортировка" />
                </SelectTrigger>
                <SelectContent>
                  <SelectItem value="earnings">Доход</SelectItem>
                  <SelectItem value="sales">Продажи</SelectItem>
                  {/* <SelectItem value="views">Просмотры</SelectItem> */}
                  <SelectItem value="price">Цена</SelectItem>
                  <SelectItem value="title">Название</SelectItem>
                </SelectContent>
              </Select>
            <Button
              variant="outline"
              size="sm"
              onClick={() => setSortOrder(sortOrder === 'asc' ? 'desc' : 'asc')}
              className="w-full sm:w-auto"
            >
              {sortOrder === 'asc' ? '↑' : '↓'}
            </Button>
          </div>
        </div>

        {/* All Documents Table */}
        <div className="bg-white rounded-lg border">
            <div className="p-4 sm:p-6 border-b">
            <h3 className="font-semibold flex items-center gap-2 text-sm sm:text-base">
                <FileText className="h-4 w-4 sm:h-5 sm:w-5" />
                Все документы платформы
            </h3>
            </div>
            <div className="p-3 sm:p-6">
            <div className="overflow-x-auto -mx-3 sm:mx-0">
                <div className="min-w-[600px] px-3 sm:px-0">
                <table className="w-full">
                    <thead>
                    <tr className="border-b bg-gray-50">
                        <th className="text-left p-2 sm:p-3 font-medium text-xs sm:text-sm">Документ</th>
                        <th className="text-left p-2 sm:p-3 font-medium text-xs sm:text-sm">Дата</th>
                        <th className="text-left p-2 sm:p-3 font-medium text-xs sm:text-sm">Цена</th>
                        <th className="text-left p-2 sm:p-3 font-medium text-xs sm:text-sm">Статус</th>
                        <th className="text-left p-2 sm:p-3 font-medium text-xs sm:text-sm">Комиссия</th>
                    </tr>
                    </thead>
                    <tbody>
                    {analyticsStats.filter(d =>
                  d.title.toLowerCase().includes(searchTerm.toLowerCase()) &&
                  (statusFilter === 'all' || d.status === statusFilter)
                )
                .sort((a, b) =>
                  sortOrder === 'asc'
                    ? a[sortBy] - b[sortBy]
                    : b[sortBy] - a[sortBy]
                )
                    .map((doc) => (
                        <tr key={doc.id} className="border-b hover:bg-gray-50">
                        <td className="p-2 sm:p-3">
                            <div className="flex items-center gap-2">
                            <FileText className="h-3 w-3 sm:h-4 sm:w-4 text-gray-500 flex-shrink-0" />
                            <span className="text-xs sm:text-sm font-medium max-w-xs truncate">
                                {doc.title}
                            </span>
                            </div>
                        </td>
                        <td className="p-2 sm:p-3">
                            <span className="text-xs sm:text-sm">{doc.created_at.split(' ')[0]}</span>
                        </td>
                        <td className="p-2 sm:p-3">
                            <span className="text-xs sm:text-sm">{doc.price}₽</span>
                        </td>
                        <td className="p-2 sm:p-3">
                            {doc.status === 'approved' ? (
                        <Badge className="bg-green-100 text-green-800">
                          Активен
                        </Badge>
                      ) : (
                        <Badge variant="outline" className="text-yellow-600">
                          Модерация
                        </Badge>
                      )}
                        </td>
                        <td className="p-2 sm:p-3">
                            <span className="text-xs sm:text-sm text-green-700">
                            {doc.status === 'approved' ? `${(doc.price * 0.05).toFixed(0)}₽` : '—'}
                            </span>
                        </td>
                        </tr>
                    ))}
                    </tbody>
                </table>
                </div>
            </div>
            </div>
        </div>
        </div>
    )
}
